import { type Employee, EmployeeStatus, Role } from "@pentacode/core";
import { IS_DEV } from "../env";
import { app, appMode } from "../init";
import type { RouteAccess } from "../lib/route-tree";

export function routeAccess(employee?: Employee): RouteAccess {
    return {
        hasPermission: (permission) => app.hasPermission(permission),
        embedded: appMode === "embedded",
        dev: IS_DEV,
        company: app.company,
        role: app.profile?.role,
        owner: !!app.account?.admin || (app.profile?.role ?? Role.Worker) <= Role.Owner,
        employee: employee
            ? { accessible: app.hasAccess({ employee }), probation: employee.status === EmployeeStatus.Probation }
            : null,
    };
}
